import { Button as e } from "../../button/primitive/button.js";
import { ChevronLeftIcon as t, ChevronRightIcon as n } from "@systemeio/icons";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { useMediaQuery as a } from "@systemeio/util";
//#region src/date-picker/primitive/date-picker-header.tsx
function o({ date: o, decreaseMonth: s, increaseMonth: c, intlLocale: l, hidePrevButton: u, hideNextButton: d, nextMonthButtonDisabled: f, prevMonthButtonDisabled: p }) {
	let { isMobile: m } = a();
	return /* @__PURE__ */ i("div", {
		className: "border-border-200 tablet:border-b flex items-center justify-between p-4 pt-5",
		children: [
			u ? /* @__PURE__ */ r("span", {}) : /* @__PURE__ */ r(e, {
				"aria-label": "Previous month",
				size: m ? "icon-md" : "icon-xs",
				variant: "ghost-gray",
				disabled: p,
				onClick: s,
				children: /* @__PURE__ */ r(t, {})
			}),
			/* @__PURE__ */ r("span", {
				className: "text-text-secondary tablet:text-base text-lg font-normal",
				children: new Intl.DateTimeFormat(l, {
					month: "long",
					year: "numeric"
				}).format(o)
			}),
			d ? /* @__PURE__ */ r("span", {}) : /* @__PURE__ */ r(e, {
				"aria-label": "Next month",
				size: m ? "icon-md" : "icon-xs",
				variant: "ghost-gray",
				disabled: f,
				onClick: c,
				children: /* @__PURE__ */ r(n, {})
			})
		]
	});
}
//#endregion
export { o as DatePickerHeader };
